import React from "react"
import Card from "../../../containers/Card/Card"
import {GridContainer} from "../../../containers/GridContainer/GridContainer"
import ServiceMessageForm from "./ServiceMessageForm/ServiceMessageForm"
import {useAccessToken} from "../../../services/auth"
import {useAsyncResult} from "../../../hooks/useAsyncResult"
import {findBanks} from "../../../resources/bank"
import {AsyncResultComponent} from "../../../containers/AsyncResult/AsyncResult"
import Skeleton from "react-loading-skeleton"

export default function ISOServiceMessage() {
	const accessToken = useAccessToken()
	const banks = useAsyncResult(() => findBanks(accessToken, 0, 1000, ""), [])
	return (
		<AsyncResultComponent
			asyncResult={banks}
			pendingComponent={
				<GridContainer rows={1} columns={2}>
					<Skeleton height={400} />
					<Skeleton height={400} />
				</GridContainer>
			}
		>
			{({value: banks}) => (
				<GridContainer rows={1} columns={2} gap="20px" responsive>
					<Card title="Send Wire ISO Service Message - For Payment">
						<ServiceMessageForm banks={banks} />
					</Card>
					<Card title="Send Wire ISO Service Message - For Incoming Message">
						<ServiceMessageForm banks={banks} incoming />
					</Card>
				</GridContainer>
			)}
		</AsyncResultComponent>
	)
}
